<div class="o-page">
    @if (!isIFrame()) {
        <div class="white-square"></div>
    }
    <div frame class="panel">
        <div class="panel">
            <iframe class="panel__frame" [id]="iFrameId" frameborder="0" src="mediator" scrolling="no"></iframe>
        </div>
    </div>
</div>
